import React,{useState} from 'react'
import { Icon, Dialog, Alert, Collapse } from '@blueprintjs/core';
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import { doc, deleteDoc } from 'firebase/firestore'
import db from '../firebase/config'
import Picker from 'emoji-picker-react';
var moment = require('moment')
moment.utc().format(); 

const auth = getAuth()


function Stack(props) {
  const {owner,owner_photo, owner_name,timeStamp, title, stackDocId} = props.info
  let timeNew = new Date(timeStamp.seconds * 1000)
  const [user] = useAuthState(auth)
  const [visible,setVisible] = useState(false)
  const [alert,showAlert] = useState(false)

  const deleteStack = async()=>{
        let docRef = doc(db, "stacks",stackDocId);
        await deleteDoc(docRef)
        await setVisible(false)
        await showAlert(true)
  }

    return (
        <div id="stack-wrapper">
             <div id="just-bar">
                <img src={owner_photo} style={{width:35,height:35,borderRadius:20,margin:10}} />
                    <div>
                    <h3 style={{color: '#ecf1f5'}}>{owner_name}</h3>
                        <p style={{color: '#DDD',marginTop:-14,fontSize:9}}>{owner}</p>
                    </div>
                    <p id="caption">{moment.utc(timeNew).format('MMM Do YY, h:mm')}</p>
                    {user.email === owner ? <div id="more-btn" onClick={()=>setVisible(prev=>!prev)}><Icon icon="more"   color="#ecf1f5"  style={{marginLeft:10}}/></div> : <div />}
            </div>
             <div id="side-line">
                <p id="p" style={{marginLeft:'5%',paddingTop:14,fontSize:20,}}>{title}</p>
             </div>


             <Dialog isOpen={visible} style={{backgroundColor:'#30404D'}} onClose={()=>setVisible(prev=>!prev)} canOutsideClickCancel={true}>
             <h3 id="h3">Are you sure you want to delete this stack</h3>
             <div id="action-btn" onClick={()=>deleteStack()}>
                        <Icon icon="trash" color="#ecf1f5" style={{marginRight:10}} /> 
                          Delete stack
                    </div>
             </Dialog>

             
             <Alert isOpen={alert}  onClose={()=>showAlert(prev=>!prev)} canOutsideClickCancel={true}>
                  Stack deleted successfully
              </Alert>
             
        </div>
    )
}

export default Stack
